import React from "react";
import "./GosiDetailPopup.css";
import downloadIcon from "../../../../assets/icons/download.png";
import { fileDownload } from "../../../../functions/Functions";
import { getServerBaseUrl } from "../../../../utils/portConfig";

function GosiPopup({ data, onClose, onDelete, selectedRow, token }) {
  const chkAuth = localStorage.getItem("auth");

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/gosi`;

  const handleOverlayClick = (e) => {
    if (e.target.className === "gosi-popup-overlay") {
      onClose();
    }
  };

  // 임시: 고시 첨부파일 삭제 로직
  const gosiFileDelete = async () => {};

  const renderAttachments = () => {
    if (data.attachments && data.attachments.length > 0) {
      return (
        <div className="gosi-popup-attachments">
          <ul className="gosi-attachment-list">
            {data.attachments.map((attachment) => (
              <li key={attachment.id} className="attachment-item">
                <div className="attachment-info" onClick={() => fileDownload(attachment, token)} style={{ cursor: "pointer" }}>
                  <span>첨부파일: </span>
                  <span className="attachment-filename">{attachment.filename}</span>
                  <a className="attachment-download-link">
                    <img src={downloadIcon} alt="Download" style={{ width: "20px", verticalAlign: "text-bottom" }} className="download-icon" />
                    {/*<span className="delete-gosi-button" onClick={gosiFileDelete}>x</span>*/}
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    }
    return null;
  };

  const renderDeleteButton = () => {
    if (selectedRow && selectedRow.sno === 99 && chkAuth === "Superadmin") {
      return (
        <button className="gosi-pipup-button" style={{ marginRight: "10px", backgroundColor: "red" }} onClick={onDelete}>
          삭제
        </button>
      );
    }
    //return null;
  };

  return (
    <div className="gosi-popup-overlay" onClick={handleOverlayClick}>
      <div className="gosi-popup">
        <h2 className="gosi-popup-header">{data.title}</h2>
        <div className="gosi-popup-body">
          <div className="gosi-popup-body-header">
            <div className="gosi-popup-info">
              {/* <span>분류: {data.grpName}</span> */}
              <span>관련근거: {data.evidence}</span>
              <span>게시일: {data.regdt}</span>
            </div>
            {renderAttachments()}
          </div>
          <div className="gosi-popup-content" dangerouslySetInnerHTML={{ __html: data.tagcontents }} />
          <div className="gosi-popup-button-container">
            {renderDeleteButton()}
            <button className="gosi-popup-button" onClick={onClose}>
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GosiPopup;
